// extracted by mini-css-extract-plugin
export default {"wrapper":"EfficiencyClass__wrapper--aVvN4"};